'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});


/* eslint-disable */
function Column(props) {
  return null;
}

Column.defaultProps = {
  width: 100
};

exports.default = Column;


//////////////////
// WEBPACK FOOTER
// ./node_modules/rsuite-table/lib/Column.js
// module id = 1974
// module chunks = 0